/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Manual_HelpInputs */

const en_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Event Groups are created based on the segmentation data provided by the user.`)
};

const fr_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De nouveaux groupes d'evenements sont crees en fonction des donnees de segmentation fournies par l'utilisateur.`)
};

const de_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ereignisgruppen werden auf Basis der vom Benutzer bereitgestellten Segmentierungsdaten erstellt.`)
};

const it_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I nuovi gruppi di eventi vengono creati in base ai dati di segmentazione forniti dall'utente.`)
};

const ru_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые группы событий создаются на основе данных сегментации, предоставленных пользователем.`)
};

const es_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se crean nuevos grupos de eventos según los datos de segmentación proporcionados por el usuario.`)
};

const zh_cn2_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据用户提供的细分数据创建新的事件组。`)
};

const ja_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーが提供するセグメンテーション データに基づいて、新しいイベント グループが作成されます。`)
};

const hi_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता द्वारा प्रदान किए गए विभाजन डेटा के आधार पर नए इवेंट समूह बनाए जाते हैं।`)
};

const pt_pt2_segment_event_group_manual_help = /** @type {(inputs: Segment_Event_Group_Manual_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos grupos de eventos são criados com base nos dados de segmentação fornecidos pelo usuário.`)
};

/**
* | output |
* | --- |
* | "New Event Groups are created based on the segmentation data provided by the user." |
*
* @param {Segment_Event_Group_Manual_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_manual_help = /** @type {((inputs?: Segment_Event_Group_Manual_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Manual_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_manual_help(inputs)
	if (locale === "de") return de_segment_event_group_manual_help(inputs)
	if (locale === "it") return it_segment_event_group_manual_help(inputs)
	if (locale === "ru") return ru_segment_event_group_manual_help(inputs)
	if (locale === "es") return es_segment_event_group_manual_help(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_manual_help(inputs)
	if (locale === "ja") return ja_segment_event_group_manual_help(inputs)
	if (locale === "hi") return hi_segment_event_group_manual_help(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_manual_help(inputs)
	return en_segment_event_group_manual_help(inputs)
});